import Button from 'components/Button/Button';
import { useTranslation } from 'react-i18next';

export default function DesktopCalculatorButton({
  disabled,
  onClick,
}: {
  disabled: boolean;
  onClick: () => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="hidden lg:block">
      <Button
        disabled={disabled}
        onClick={onClick}
        size="m"
        wide
        outline
        dataTest="sidebar-btn-edit-calculator"
      >
        {t('common:edit')}
      </Button>
    </div>
  );
}
